export const Coin = {
  methods: {
    //get coin transaction
    fetchData(sendData, type) {
      this.loader = true;
      this.mTop = true;
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      var cardHolderInfId = user.cardHolderInfId;
      var pageNumber = sendData || 1;
      var transactionListType = "Coin";
      var transactionType = "";
      if (type == "StoreManagement") {
        transactionType = "All";
      } else if (!type) {
        transactionType = "All";
      } else {
        transactionType = type;
      }
      if (transactionType === "All") {
        var isPartnerTransaction = -1;
      } else {
        var isPartnerTransaction = 0;
      }
      let beginDate = this.newStartDate;
      let endDate = this.newEndDate;
      this.$axiosApi
        .post(`card/transactions`, {
          tokenId,
          cardHolderInfId,
          pageSize: 12,
          transactionListType,
          pageIndex: pageNumber,
          transactionType,
          isPartnerTransaction,
          beginDate,
          endDate,
        })
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.pageIndex = result.pageIndex;
            this.totalPage = result.totalPageCount;
            this.transactions = result.transactions;
            this.loader = false;
            this.mTop = false;
            this.scrollToTop();
          } else if (result.status === 201) {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch((error) => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    //coin date filter
    dateFilter(Startdate, Enddate) {
      var beginDate = Startdate.substring(0, 10);
      var endDate = Enddate.substring(0, 10);
      if (beginDate.length > 0 && endDate.length > 0) {
        this.newStartDate = Startdate;
        this.newEndDate = Enddate;
        this.loader = true;
        this.mTop = true;
        var tokenId = localStorage.getItem("authToken");
        var user = this.$auth.getMe();
        if (tokenId == null || user == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var cardHolderInfId = user.cardHolderInfId;
        var transactionListType = "Coin";
        var transactionType = this.selectTransactionType || "All";
        if (this.selectTransactionType === "All") {
          var isPartnerTransaction = -1;
        } else {
          var isPartnerTransaction = 0;
        }
        this.$axiosApi
          .post(`card/transactions`, {
            tokenId,
            cardHolderInfId,
            transactionListType,
            transactionType,
            isPartnerTransaction,
            pageSize: 12,
            pageIndex: 1,
            beginDate,
            endDate,
          })
          .then((response) => {
            var result = response.data;
            if (result.status === 0) {
              this.pageIndex = result.pageIndex;
              this.totalPage = result.totalPageCount;
              this.transactions = result.transactions;
              this.loader = false;
              this.mTop = false;
            } else if (result.status === 201) {
              this.RedirectLogin();
              this.$auth.destroyToken();
              this.$auth.removeMe();
              this.$router.push({ name: "login" });
            }
          })
          .catch((error) => {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          });
      } else {
        this.errorMessage = "Утгыг гүйцэт бөглөнө үү ?";
        this.errorModal = true;
      }
    },
    openModal(value) {
      if (value.transactionType != "ByHand") {
        //get one coin
        this.loader = true;
        this.$insProgress.start();
        var tokenId = localStorage.getItem("authToken");
        var user = this.$auth.getMe();
        if (tokenId == null || user == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var cardHolderInfId = user.cardHolderInfId;
        var invPkId = value.invPkId;
        var invType = value.transactionType;
        this.$axiosApi
          .post(`card/transactions/detail`, {
            tokenId,
            cardHolderInfId,
            invPkId,
            invType,
          })
          .then((response) => {
            var result = response.data;
            if (result.status === 0) {
              this.modalData = result.bills;
              this.coin = true;
              this.headerData = result;
              this.showModal = true;
              this.loader = false;
              this.$insProgress.finish();
            } else if (result.status === 201) {
              this.RedirectLogin();
              this.$auth.destroyToken();
              this.$auth.removeMe();
              this.$router.push({ name: "login" });
            }
          })
          .catch((error) => {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          });
      }
    },
    //get one data bill
    openBill(value) {
      if (
        value.transactionType != "ByHand" &&
        value.transactionType != "TransferCommission" &&
        value.transactionType !== "Transfer"
      ) {
        this.loader = true;
        this.$insProgress.start();
        var tokenId = localStorage.getItem("authToken");
        var user = this.$auth.getMe();
        if (tokenId == null || user == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var cardHolderInfID = user.cardHolderInfId;
        var invPkId = value.invPkId;
        var type = "Bonus";
        var billPkId = value.billPkId;
        this.$axiosApi
          .post(`card/get/billImage`, {
            tokenId,
            cardHolderInfID,
            billPkId,
            type,
          })
          .then((response) => {
            var result = response.data;
            this.showBill = true;
            if (result.status === 1) {
              this.billData = result.data;
              this.invPkId = invPkId;
              this.headerData = result;
            } else {
              this.billData = "";
              this.billMessage = result.message;
            }
            this.loader = false;
            this.$insProgress.finish();
          })
          .catch((error) => {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          });
      }
    },
    //get type find
    filterType(value, partnerId) {
      this.loader = true;
      this.mTop = true;
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.RedirectLogin();
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      var cardHolderInfId = user.cardHolderInfId;
      var transactionListType = "Coin";
      var transactionType = value;
      var isPartnerTransaction = partnerId;
      this.$axiosApi
        .post(`card/transactions`, {
          tokenId,
          cardHolderInfId,
          transactionListType,
          transactionType,
          isPartnerTransaction,
          pageSize: 12,
          pageIndex: 1,
        })
        .then((response) => {
          var result = response.data;
          if (result.status === 0) {
            this.pageIndex = result.pageIndex;
            this.totalPage = result.totalPageCount;
            this.transactions = result.transactions;
            this.loader = false;
            this.mTop = false;
            this.selectTransactionType = this.transactions[0].transactionType;
          } else if (result.status === 201) {
            this.RedirectLogin();
            this.$auth.destroyToken();
            this.$auth.removeMe();
            this.$router.push({ name: "login" });
          }
        })
        .catch((error) => {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
  },
};
